export const links = [
  {
    to: "/",
    title: "Home"
  },
  {
    to: "mailto: support@greenlistapp.com",
    title: "Support"
  }
];
